
import { defineComponent } from 'vue';
import { adFilterService } from '@/ad/AdFilterService';

export default defineComponent({
  data() {
    return {
      isLoading: false,
      pagedList: {
        data: [],
        page: 1,
        pageSize: 20,
        currentCount: 0,
        totalCount: 0,
      },
    };
  },
  async created() {
    await this.search();
  },
  methods: {
    async search() {
      try {
        this.isLoading = true;

        this.pagedList = (await adFilterService.get(null)).data;
      } catch (error) {
        //this.handleApiError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async remove(adFilterId: string) {
      const result = await adFilterService.delete(adFilterId);
      if (result.status === 200) {
        await this.search();
      }
    },
  },
});
